import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../../../services/auth.service';
import {Customer} from '../../../models/CustomerInfo/Customer';
import {RegistryService} from '../../../services/registry.service';
import {CustomerAddress} from '../../../models/CustomerInfo/CustomerAddress';
import {CartService} from '../../../services/cart.service';
import {ConfirmationDialogComponent} from '../../../../shared/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {NewShippingAddressComponent} from './new-shipping-address/new-shipping-address.component';
import {MagentoCustomerService} from '../../../../../services/magentocustomer.service';
import {Cart} from '../../../models/CartModels/cart';

@Component({
    selector: 'app-checkout-shipping-address',
    templateUrl: './checkout-shipping-address.component.html',
    styleUrls: ['./checkout-shipping-address.component.css']
})
export class CheckoutShippingAddressComponent implements OnInit, OnDestroy {


    status = null;
    selectedAddress: CustomerAddress = new CustomerAddress();
    showAll = true;
    cart: Cart;

    customer: Customer;

    addressUpdatedEvent;
    customerLoadedEvent;
    productQtyUpdatedEvent;
    cartChangedEvent;

    constructor(private authService: AuthService,
                public registry: RegistryService,
                private cartService: CartService, private dialog: MatDialog, private customerService: MagentoCustomerService) {
        this.cartChangedEvent = cartService.CartChangedEvent$.subscribe(cart => {
            this.cart = cart;

            // console.log('from shipping address');
            // console.log(this.cart);



        });

        this.productQtyUpdatedEvent = cartService.ProductQtyUpdatedEvent$.subscribe(cartItem => {

            // console.log(cartItem);
            // console.log(this.cart);


            const index = this.cart.items.findIndex((el) => el.item_id === cartItem.item_id);
            this.cart.items[index] = cartItem;

            let subTotal = 0;

            for (let i = 0; i < this.cart.items.length; i++) {
                let newPrice = Math.round(((this.cart.items[i].price * this.cart.items[i].qty) + Number.EPSILON) * 100) / 100;
                subTotal += newPrice;

            }

            console.log(subTotal);
            if(subTotal > 5){
                this.reset();
                if (this.registry.customer != null) {
                    this.customer = this.registry.customer;
                    if (this.customer.addresses.length > 0) {
                        this.setAddressSelected(this.customer.addresses[0]);
                    }
                }
            }else {
                this.reset();
                this.cartService.checkCartReady();
                this.cartService.checkOrderReady();
                // if (this.registry.customer != null) {
                //     this.customer = this.registry.customer;
                //     if (this.customer.addresses.length > 0) {
                //         this.setAddressSelected(this.customer.addresses[0]);
                //     }
                // }
            }


        });

        this.authService.UserLoggedInEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;
            this.showAll = true;

        });


        this.addressUpdatedEvent = this.cartService.ShippingAddressUpdatedEvent$.subscribe(address => {

            this.selectedAddress = address;
            this.showAll = false;

        });

        this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;
            this.showAll = true;

        });

    }

    ngOnDestroy(): void {

        // this.addressUpdatedEvent.unsubscribe();
        // this.customerLoadedEvent.unsubscribe();
        this.productQtyUpdatedEvent.unsubscribe();
    }

    ngOnInit(): void {

        if (this.registry.customer != null) {
            this.customer = this.registry.customer;
            if (this.customer.addresses.length > 0) {
                this.setAddressSelected(this.customer.addresses[0]);
            }
        }
    }

    showAllAddresses(event) {
        event.preventDefault();

        this.showAll = true;

    }

    deleteSelectedAddresses(event) {
        event.preventDefault();
        const index = this.customer.addresses.findIndex((el) => el === this.selectedAddress);
        this.customer.addresses.splice(index, 1);
        this.registry.customer = this.customer;
        this.customer.websiteId = this.registry.getWebsiteId();

        this.customerService.updateCustomerData(this.customer).subscribe(result => {

            this.customerService.getCustomerInfo().subscribe(customer => {

                this.registry.customer = customer;
                this.registry.EmitCustomerLoaded(customer);

            });

        });

        this.cartService.checkCartReady();
        this.cartService.checkOrderReady();


    }

    setAddressSelected(address: CustomerAddress) {


        if (address.id != this.selectedAddress.id) {
            this.cartService.selectedShippingAddress = address;
            this.selectedAddress = address;
            this.cartService.EmitShippingAddressUpdated(address);
        } else {
            this.cartService.selectedShippingAddress = null;
            this.selectedAddress = new CustomerAddress();
            this.showAll = true;
        }

        this.cartService.checkCartReady();
        this.cartService.checkOrderReady();
    }

    openAddressDialog(event, id: number) {

        event.preventDefault();
        const dialogRef = this.dialog.open(NewShippingAddressComponent, {
            width: '750px',
            data: {id: id, parent: this}

        });

    }

    reset() {

        this.customer = null;
        this.selectedAddress = new CustomerAddress();
    }

}
